module.exports = __webpack_public_path__ + "img/base_activites_junior.eb362eaf.svg";